import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=53f68b53&scoped=true"
import script from "./chapter.vue?vue&type=script&lang=js"
export * from "./chapter.vue?vue&type=script&lang=js"
import style0 from "./chapter.vue?vue&type=style&index=0&id=53f68b53&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f68b53",
  null
  
)

export default component.exports